const boxCarouselHover = async function () { 
    if ( 
        document.querySelector(".boxCarouselHover") && document.querySelector(".boxCarouselHover__btn") ) {
        const boxCarouselHover = document.querySelectorAll(".boxCarouselHover");
        
        boxCarouselHover.forEach(item => {
            const btn = item.querySelector(".boxCarouselHover__btn"),
                image = item.querySelector(".boxCarouselHover__image"),
                content = item.querySelector(".boxCarouselHover__content");
            
            btn.addEventListener("click", () => {
                btn.classList.toggle("rotate-45");
                image.classList.toggle("opacity-0");
                content.classList.toggle("opacity-0");
            });
        })
    }
}

export const init = boxCarouselHover;